module.exports = __webpack_public_path__ + "img/top4.ffc8db7d.png";